import RegisterCompany from "../views/RegisterCompany.vue";
import HomePage from "../views/HomePage.vue";
import SuccessPage from "../views/SuccessPage.vue";
import CancelPage from "../views/CancelPage.vue";
import MyHome from "../views/MyHome.vue";
import MyProfile from "../views/MyProfile.vue";
import PricingPage from "../views/PricingPage.vue";
import ResidentsList from "../views/ResidentsList.vue";
import ResidentDocument from "../views/ResidentDocument.vue";
import ResidentContact from "../views/ResidentContact.vue";
import ResidentInsurance from "../views/ResidentInsurance.vue";
import ResidentProvider from "../views/ResidentProvider.vue";
import ResidentVital from "../views/ResidentVital.vue";
import ResidentCharting from "../views/ResidentCharting.vue";
import ResidentAdl from "../views/ResidentAdl.vue";
import ResidentSchedule from "../views/ResidentSchedule.vue";
import EmployeesList from "../views/EmployeesList.vue";
import CompanyDashboard from "../views/CompanyDashboard.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import TermsOfUse from "@/views/TermsOfUse.vue";
import OperationsDashboard from "@/views/OperationsDashboard.vue";
import OfficeLocations from "@/views/OfficeLocations.vue";
import LogIn from "../views/LogIn.vue";
import TimeSheets from "@/views/TimeSheets.vue";
import PayrollReports from "@/views/PayrollReports.vue";
import ContactForm from "../views/ContactForm.vue";
import { checkTokenExpiration } from '../utils/auth';
import store from '../store/store.js';
import { getUserRole } from "@/components/values";
import { createRouter, createWebHistory } from "vue-router";


const routes = [
 {
   path: "/pricing",
   name: "pricing",
   component: PricingPage,
 },
 {
   path: "/",
   name: "myhome",
   component: MyHome,
 },
 {
   path: "/myprofile",
   name: "myprofile",
   component: MyProfile,
   meta: { requiresAuth: true, requiredRole:'admins' }
 },
 {
   path: "/registercompany",
   name: "registercompany",
   component: RegisterCompany,
 },
 {
   path: "/home",
   name: "home",
   component: HomePage,
 },
 {
  path: "/contactform",
  name: "contactform",
  component: ContactForm,
},
 {
  path: "/login",
  name: "login",
  component: LogIn,
},
 {
   path: "/cancel",
   name: "cancel",
   component: CancelPage,
   meta: { requiresAuth: true }
 },
 {
   path: "/success",
   name: "success",
   component: SuccessPage,
   meta: { requiresAuth: true }
 },
 {
    path: "/residentslist:id",
    name: "residentslist",
    component: ResidentsList,
    meta: { requiresAuth: true }
  },
  {
    path: "/residentdocument:id",
    name: "residentdocuments",
    component: ResidentDocument,
    meta: { requiresAuth: true }
  },
  {
    path: "/residentcontact:id",
    name: "residentcontacts",
    component: ResidentContact,
    meta: { requiresAuth: true }
  },
  {
    path: "/residentinsurance:id",
    name: "residentinsurances",
    component: ResidentInsurance,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/residentprovider:id",
    name: "residentproviders",
    component: ResidentProvider,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/residentvital:id",
    name: "residentvitals",
    component: ResidentVital,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/residentcharting:id",
    name: "residentcharting",
    component: ResidentCharting,
  }, 
  {
    path: "/residentadl:id",
    name: "residentadl",
    component: ResidentAdl,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/residentschedule",
    name: "residentschedule",
    component: ResidentSchedule,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/employeeslist",
    name: "employeeslist",
    component: EmployeesList,
    meta: { requiresAuth: true, requiredRole:'admins' }
  }, 
  {
    path: "/companydashboard",
    name: "companydashboard",
    component: CompanyDashboard,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/operationsdashboard",
    name: "operationsdashboard",
    component: OperationsDashboard,    
    meta: { requiresAuth: true, requiredRole:'admins' }
  }, 
  {
    path: "/offices",
    name: "offices",
    component: OfficeLocations,
    meta: { requiresAuth: true, requiredRole:'admins' }
  }, 
   {
    path: "/payrollreports",
    name: "payrollreports",
    component: PayrollReports,
    meta: { requiresAuth: true, requiredRole:'admins' }
  }, 
   {
    path: "/timesheets",
    name: "timesheets",
    component: TimeSheets,
    meta: { requiresAuth: true, requiredRole:'admins' }
  }, 
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: PrivacyPolicy,
  }, 
  {
    path: "/termsofuse",
    name: "termsofuse",
    component: TermsOfUse,
  }, 
  {
  path: '/unauthorized',
  name: 'unauthorized',
  component: () => import('@/views/Unauthorized.vue')
}
];

const router = createRouter({
 history: createWebHistory(),
 routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = checkTokenExpiration();
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    store.dispatch('logout');
    next({ name: 'login' });
  } 
   const requiredRole = to.meta.requiredRole;
  if (requiredRole && !getUserRole(requiredRole)) {
    return next({ name: 'unauthorized' }); // define this route
  }

  next();

});


export default router;
